import PdvActivateForm from './activate_form';
import AddCadForm from '../components/AddCadForm';
import PdvDetail from './detail';
import PdvEditForm from './edit';
import PdvParkingHistoryList from './parking_history_list';
import SetAdmForm from '../components/SetAdmForm';
import PdvTransactionsHistoryList from './transactions_history_list';
import PdvVehiclesParkedList from './vehicles_parked_list';

const Controls = {
  PdvActivateForm,
  AddCadForm,
  PdvDetail,
  PdvEditForm,
  PdvParkingHistoryList,
  SetAdmForm,
  PdvTransactionsHistoryList,
  PdvVehiclesParkedList
}

export default Controls;
